import React from "react";
import * as Icons from "@heroicons/react/24/outline";

interface IconRendererProps {
  name?: string;
  className?: string;
}

function toPascalCase(input?: string) {
  if (!input) return "";
  return (
    input
      .split(/[-_ ]+/)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("") + "Icon"
  );
}

export function IconRenderer({ name, className = "size-6 text-violet-950" }: IconRendererProps) {
  const key = toPascalCase(name);
  const IconComp = (Icons as Record<string, React.ComponentType<any>>)[key] || Icons.StarIcon;
  return <IconComp className={className} aria-hidden />;
}


